// extracted by mini-css-extract-plugin
export var footer = "_r1-0";
export var inherit = "_r1-1";
export var input = "_r1-2";
export var modalContent = "_r1-3";
export var quillEditor = "_r1-4";
export var subtitle = "_r1-5";